module.exports = __webpack_public_path__ + "static/img/amaraViewFullFaceMask.3ade18d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/amaraViewFullFaceMask.png
// module id = TX3N
// module chunks = 1